import { createAction } from 'redux-actions';
import { makeActionType } from '../utils';

const namespace = 'SETTINGS';

export const fetchSettings = createAction(makeActionType(namespace, ['FETCH']));

export const setSettings = createAction(makeActionType(namespace, ['SET']));
